import { 
  Component, 
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  Inject,
  ViewChild,
  forwardRef
} from '@angular/core';

import { isEqual, isNil } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FormGroup, FormControl, Validators} from '@angular/forms';
import { DatexFormControl } from './models/datex-form-control';
import { ListItemModel, ELoadingStatus } from './components/list.component';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_dock_appointment_activity_list_ComponentContextService } from './FootprintManager.dock_appointment_activity_list.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { FootprintManager_dock_appoinment_activity_cardComponent } from './FootprintManager.dock_appoinment_activity_card.component';

interface IFootprintManager_dock_appointment_activity_listComponentEntity {
dockAppointmentId?: number, activityTitle?: string, activityDetails?: string, activityUser?: string, activityStyle?: string, activityDate?: string}

class FootprintManager_dock_appointment_activity_listComponentItemModel extends ListItemModel {
  list: FootprintManager_dock_appointment_activity_listComponent;
  entity: IFootprintManager_dock_appointment_activity_listComponentEntity;



  get $content_FootprintManager_dock_appoinment_activity_card_inParams_dockAppointmentId(): number {
    if (!this.entity) return null; 
    const $item = this;
    const $utils = this.$utils;
    const $list = this.list;
    const expr = $item.entity.dockAppointmentId;
    
    return expr;
  }


  get $content_FootprintManager_dock_appoinment_activity_card_inParams_activityDetails(): string {
    if (!this.entity) return null; 
    const $item = this;
    const $utils = this.$utils;
    const $list = this.list;
    const expr = $item.entity.activityDetails;
    
    return expr;
  }


  get $content_FootprintManager_dock_appoinment_activity_card_inParams_activityDate(): string {
    if (!this.entity) return null; 
    const $item = this;
    const $utils = this.$utils;
    const $list = this.list;
    const expr = $utils.date.format($item.entity.activityDate, $list.vars.dateFormat);
    
    return expr;
  }


  get $content_FootprintManager_dock_appoinment_activity_card_inParams_activityUser(): string {
    if (!this.entity) return null; 
    const $item = this;
    const $utils = this.$utils;
    const $list = this.list;
    const expr = $item.entity.activityUser;
    
    return expr;
  }


  get $content_FootprintManager_dock_appoinment_activity_card_inParams_style(): string {
    if (!this.entity) return null; 
    const $item = this;
    const $utils = this.$utils;
    const $list = this.list;
    const expr = $item.entity.activityStyle;
    
    return expr;
  }


  get $content_FootprintManager_dock_appoinment_activity_card_inParams_title(): string {
    if (!this.entity) return null; 
    const $item = this;
    const $utils = this.$utils;
    const $list = this.list;
    const expr = $item.entity.activityTitle;
    
    return expr;
  }

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_dock_appointment_activity_list_ComponentContextService,
   ) {
    super();
  }

  private $unsubscribe$ = new Subject();
  destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $initializeExisting(list: FootprintManager_dock_appointment_activity_listComponent, entity: IFootprintManager_dock_appointment_activity_listComponentEntity) {
    this.list = list;
    this.entity = entity;

    this.styles = new Styles(
       null, 
      { 
        width: '90%', 
        height: '250px' 
      }
    );
  }
}

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootprintManager_dock_appoinment_activity_cardComponent)
  ],
  selector: 'FootprintManager-dock_appointment_activity_list',
  templateUrl: './FootprintManager.dock_appointment_activity_list.component.html'
})
export class FootprintManager_dock_appointment_activity_listComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { dockAppointmentId: number } = { dockAppointmentId: null };
  //#region Inputs
  @Input('dockAppointmentId') set $inParams_dockAppointmentId(v: number) {
    this.inParams.dockAppointmentId = v;
  }
  get $inParams_dockAppointmentId(): number {
    return this.inParams.dockAppointmentId;
  }
  //#endregion Inputs

  //#region Outputs
  //#endregion
  //#region Variables
  vars: { dateFormat?: string } = { };
  //#endregion
  //#region Events
  
  //#endregion

  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title



  entities: IFootprintManager_dock_appointment_activity_listComponentEntity[] = [];
  pageSize = 5;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus: ELoadingStatus = ELoadingStatus.Loading;

  items: FootprintManager_dock_appointment_activity_listComponentItemModel[] = [];
  

  constructor(private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_dock_appointment_activity_list_ComponentContextService,
) { 
    super();
    this.title = 'Appointment history';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }
  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.dockAppointmentId)) {
        this.$missingRequiredInParams.push('dockAppointmentId');
      }
  }

  initialized = false;

  async $init() {

    const $list = this;
    const $utils = this.$utils;


    await this.on_init();

    this.initialized = true;
    this.refresh(true, true, null);
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.refresh();
  }
 
  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    this.$reset();
    const result = this.$dataLoad();
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    
  }

  $reset() {
    this.pageSkip = 0;
    this.entities = [];
    this.items.forEach(i => i.destroy());
    this.items = [];
  }


  $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $list = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      dockAppointmentId:  $list.inParams.dockAppointmentId ,
    };
    this.$datasources.DockAppointments.ds_dock_appointment_activity_list.getList(inParams)
    .then(data => {
      this.entities.push(...data.result);
      this.totalCount = data.totalCount;
      this.$dataLoaded(data.result);
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    })
    .catch(error => {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    });
  }

  async $dataLoaded(data: IFootprintManager_dock_appointment_activity_listComponentEntity[]) {
    for (let entity of data) {
      const item = new FootprintManager_dock_appointment_activity_listComponentItemModel(
        this.$utils,
        this.$settings,
        this.$shell, 
        this.$datasources,
        this.$flows,
        this.$reports,
        this.$localization,
        this.$operations,
        this.$logger,
        this.$context);
      item.$initializeExisting(this, entity);
      this.items.push(item);
    } 
  }

  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }
  
  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $list: FootprintManager_dock_appointment_activity_listComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_dock_appointment_activity_list_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  // Set Date/Time Formats
  $list.vars.dateFormat = `${$settings.DockAppointments.DateFormat}, ${$settings.DockAppointments.TimeFormat.toUpperCase() == '24 HOUR' ? 'HH:mm' : 'LT'}`;
  }
  //#endregion private flows

  close() {
    this.$finish.emit();
  }
}
